import { Injectable } from '@angular/core';
import { CodeLang } from '@common/codemirror/types/code-lang.type';
import { formatCodeByFileType, formatCodeByLang } from '@common/codemirror/util/format';
import { ProjectFileType } from '@portal-core/project-files/enums/project-file-type.enum';

@Injectable({
  providedIn: 'root'
})
export class CodeEditorService {
  /** Formats the code using the specified code language. */
  formatByLang(code: string, lang: CodeLang): string {
    return formatCodeByLang(code, lang);
  }

  /** Formats the code of the project file using its type to define the code language and additional formatting options. */
  formatByFileType(code: string, fileType: ProjectFileType): string {
    return formatCodeByFileType(code, fileType);
  }

}
